import { Component, inject, input } from '@angular/core';
import { Icon } from '../icon/icon.component';
import { IconButton } from '../button/icon-button.component';
import { FileDto } from '@api-client';
import { FileDownloadService } from '../../services/file-download.service';
import { FileSizePipe } from '../../pipes/file-size.pipe';

@Component({
  selector: 'app-file-button',
  templateUrl: './file-button.component.html',
  imports: [Icon, IconButton, FileSizePipe],
})
export class FileButton {
  file = input.required<FileDto>();
  useFileSize = input<boolean>(false);

  filsDownloadService = inject(FileDownloadService);
}
